<!--订单详情-->
<template>
  <div>
    <OrderDetailHeader
      :orderData="order"
      :payShow="payDialogShow"
      @payShowClose="payShowClose"
      @payShowSuccess="payShowSuccess"
      @payShowError="payShowError"
    ></OrderDetailHeader>

    <div class="row-box">
      <div class="row-title" v-if="order.open_seller_fenxiao==2">
        <img class="row-title-img" :src="order.business_pic_url" alt />
        {{order.business_name}}
      </div>
      <div class="row-between" v-for="(goods,index) in order.items">
        <div class="between-left">
          <img class="between-left-img" :src="goods.pic_url" alt />
          <div class="between-right">
            <div class="flex-between">
              <div class="between-left-title">{{goods.title}}</div>
              <van-tag
                plain
                type="danger"
                round
                size="medium"
                style="margin-right: 5px"
                v-if="goods.is_comment == 2 && order.order_status == 2 && order.pay_status == 2 && order.express_status == 3"
                @click="onOrderComment(goods.goods_id)"
              >评价</van-tag>
            </div>
            <div class="between-left-detail gray-light">{{goods.sku.sku_formart}}</div>
            <div class="between-sku">
              <div class="between-left-price">¥{{goods.goods_price_base}}</div>
              <div class="between-sku-right">
                <div class="between-right-num gray-light">
                  <span>数量</span>
                  {{goods.count}}
                </div>
                <div class="between-right-btn" @click="onExpressTrace(goods)">物流跟踪</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row-title">客户备注：{{order.buyer_note}}</div>
    </div>
    <div class="row-message">
      <div class="message-title">物流信息</div>
      <div class="message-li">
        <div class="message-left">配送方式</div>
        <div class="message-right gray-light">快递</div>
      </div>
      <div class="message-li">
        <div class="message-left">收货地址</div>
        <div class="message-right gray-light" v-if="order.address">
          <div class="address-pro">{{order.address.address}}</div>
          <div class="address-phone">{{order.address.name}} {{order.address.phone}}</div>
        </div>
      </div>
      <!--<div class="message-li">
          <div class="message-left">物流单号</div>
          <div class="message-right gray-light">
              顺丰 2727172627 | <span>物流跟踪</span>
          </div>
      </div>-->
    </div>
    <div class="row-message">
      <div class="message-title">订单信息</div>
      <div class="message-li">
        <div class="message-left">订单号</div>
        <div class="message-right gray-light">
          {{order.code}} |
          <span>
            <button
              type="button"
              class="btn"
              v-clipboard:copy="order.code"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >复制</button>
          </span>
        </div>
      </div>
      <div class="message-li">
        <div class="message-left">支付方式</div>
        <div class="message-right gray-light">微信在线支付</div>
      </div>
      <div class="message-li">
        <div class="message-left">下单时间</div>
        <div class="message-right gray-light">{{order.create_time_str}}</div>
      </div>
      <div class="message-li">
        <div class="message-left">支付时间</div>
        <div class="message-right gray-light">{{order.pay_time_str}}</div>
      </div>
      <div class="message-li">
        <div class="message-left">订单价格</div>
        <div class="message-right gray-light">￥{{order.order_price}}</div>
      </div>
      <div class="message-li">
        <div class="message-left">运费</div>
        <div class="message-right gray-light">￥{{order.express_price}}</div>
      </div>
      <div class="message-li">
        <div class="message-left">优惠</div>
        <div class="message-right gray-light">￥{{order.discount_price}}</div>
      </div>
      <div class="message-li">
        <div class="message-left">改价</div>
        <div class="message-right gray-light">￥{{order.fix_price}}</div>
      </div>
      <div class="message-li">
        <div class="message-left">应付金额</div>
        <div class="message-right gray-light">￥{{order.pay_price}}</div>
      </div>
      <div class="message-li">
        <div class="message-left">已付金额</div>
        <div class="message-right gray-light">￥{{order.payed_price}}</div>
      </div>
    </div>

    <van-action-sheet
      v-model="show"
      :actions="express"
      cancel-text="取消"
      @select="onSelect"
      @cancel="onCancel"
    ></van-action-sheet>
    <div class="add-btn">
      <div class="add-b-b">
        <van-button style="background:#ee0a24;border-color:#ee0a24;padding:0 0.8rem" round type="info" @click="onServiceApply"
          >发起售后</van-button
        >
      </div>
    </div>
  </div>
</template>
<style scoped>
.add-btn {
  position: fixed;
  width: 100%;
  height: 1.3rem;
  bottom: 0.4rem;
}
.add-b-b {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.order-load {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.3rem 0.24rem;
}

.load-left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.load-img {
  width: 1.2rem;
  height: 1.2rem;
  margin-right: 0.2rem;
}

.order-load-title {
  font-size: 18px;
  color: #333333;
  font-weight: 600;
}

.order-load-det {
  font-size: 12px;
  color: #7b7b7b;
  margin: 0.2rem 0;
}

.load-btn {
  width: 1.65rem;
  height: 0.48rem;
  line-height: 0.48rem;
  background: rgba(253, 40, 64, 1);
  border-radius: 0.06rem;
  text-align: center;
  font-size: 12px;
  color: #fff;
}

.load-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.row-title-img {
  width: 0.5rem;
  height: 0.5rem;
  margin-right: 0.2rem;
}

.row-box {
  border-top: 0.1rem solid #efefef;
}

.row-title {
  padding: 0.2rem 0.33rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #efefef;
}

.row-between {
  padding: 0.2rem 0;
  margin: 0 0.15rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #efefef;
}

.row-between:last-of-type {
  border: none;
}

.between-left {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}

.between-left-img {
  width: 1.1rem;
  height: 1.1rem;
  margin-left: 0.16rem;
  margin-right: 0.2rem;
}

.between-left-price {
  color: #f05656;
}

.between-left-detail {
  font-size: 11px;
  margin: 0.1rem 0;
}

.between-right-num span {
  font-size: 12px;
}

.between-right-btn {
  font-size: 12px;
  color: #0076ff;
  margin-right: 0.15rem;
  margin-left: 0.3rem;
}

.between-right {
  /* display: flex;
     justify-content: flex-start;
     align-items: flex-end;*/
  width: 79%;
  /*height: 1.2rem;*/
}

.between-sku {
  display: flex;
  justify-content: space-between;
}

.between-sku-right {
  display: flex;
}

.row-message {
  padding: 0.2rem 0.28rem;
  border-top: 0.1rem solid #efefef;
}

.message-title {
  font-weight: 600;
  color: #333333;
  padding: 0.1rem 0;
}

.message-li {
  display: flex;
  justify-content: space-between;
  padding: 0.2rem 0 0.2rem;
  border-bottom: 1px solid #efefef;
}

.row-message .message-li:last-child {
  border: none;
}

.message-right {
  font-size: 12px;
  text-align: right;
}

.message-right span {
  color: #0076ff;
}
</style>

<script>
import OrderDetailHeader from "@/components/OrderDetailHeader.vue";
import { Toast, ActionSheet } from "vant";

export default {
  name: "WyhOrderDetail",
  components: {
    OrderDetailHeader,
    Toast,
    [ActionSheet.name]: ActionSheet
  },
  data: function() {
    return {
      orderId: 0,
      order: {},
      /*payDialogShow: true,
                orderIds:0*/
      payDialogShow: false,
      show: false,
      express: []
    };
  },
  filter: {},
  mounted() {
    document.title = "订单详情";

    this.getOrderDetail();
  },
  destroyed() {},
  methods: {
    // 售后申请
    onServiceApply() {
      let that = this;
      let id = (that.orderId = this.$route.query.id);
      rbLink({
          name: 'ServiceApply',
          query: { order_id: id }
        });
      // this.$router.push({
      //   path: "/serviceapply",
      //   query: {
      //     order_id: that.orderData.id
      //   }
      // });
    },
    getOrderDetail() {
      let that = this;
      let id = (that.orderId = this.$route.query.id);

      this.$api.get("/wyhadminapi/order/areaOrderDetail", { id: id }, res => {
        that.order = res.data;
      });
      // console.log(id)
    },

    // 订单评价
    onOrderComment(goods_id) {
      let that = this;
      rbLink({
        name: "OrderCommentOperate",
        query: { id: goods_id, order_id: that.orderId }
      });
    },

    // 物流跟踪
    onExpressTrace(goods) {
      let that = this;
      if (goods.express_list.length > 1) {
        that.show = true;

        goods.express_list.map(express => {
          express.name = express.company_name + "(" + express.num + ")";
        });

        that.express = goods.express_list;
      } else if (goods.express_list.length == 1) {
        rbLink({
          name: "ExpressTrace",
          query: { id: goods.express_list[0].id }
        });
      } else {
        Toast("暂无物流信息");
      }
    },

    onSelect(item) {
      rbLink({
        name: "ExpressTrace",
        query: { id: item.id }
      });
    },

    onCancel() {
      console.log("onCancel");
    },

    // 复制订单号
    onCopy(e) {
      Toast.success("复制成功");
    },
    onError(e) {
      console.log("复制失败！");
    },

    payShowError() {
      this.payDialogShow = false;
    },

    payShowSuccess() {
      this.payDialogShow = true;
      // console.log(data);
    },

    payShowClose() {
      this.payDialogShow = false;
      this.getOrderDetail();
    }
  }
};
</script>



// WEBPACK FOOTER //
// WyhOrderDetail.vue?a9f1fa10